import { useState } from 'react';

import { Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { DeleteConfirmPopoverContent } from '@/components/atoms/DeleteConfirmPopover/DeleteConfirmPopoverContent';
import { Button } from '@/components/ui/button';
import { Popover, PopoverTrigger } from '@/components/ui/popover';

import { Credential } from '../../types';

interface DeleteAPIKeyCellProps {
  credential: Credential;
  canDelete: boolean;
  onDelete: (credential: Credential, onSettled: () => void) => void;
}

export const DeleteAPIKeyCell = ({ credential, canDelete, onDelete }: DeleteAPIKeyCellProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost-neutral"
          size="icon-sm"
          className="text-foreground-muted hover:text-destructive hover:[&_svg]:text-destructive"
          disabled={!canDelete}
          onClick={(e) => {
            e.stopPropagation();
          }}
          aria-label={t('developer_tools.credentials.delete', { 0: credential.name })}
        >
          <Trash2Icon size={16} />
        </Button>
      </PopoverTrigger>
      <DeleteConfirmPopoverContent
        side="top"
        title={t('developer_tools.delete_api_key.title')}
        description={t('developer_tools.delete_api_key.description', { 0: credential.name })}
        isLoading={isDeleting}
        onCancel={() => setOpen(false)}
        onConfirm={() => {
          setIsDeleting(true);
          onDelete(credential, () => {
            setIsDeleting(false);
            setOpen(false);
          });
        }}
        onClick={(e) => e.stopPropagation()}
      />
    </Popover>
  );
};
